import { styled } from "@mui/material/styles";

export const setPasswordFormClasses = {
	form: "form"
}

export const SetPasswordFormRoot = styled('form')(() => ({
	[`&.${setPasswordFormClasses.form}`]: {		
		display: "flex",
		flexDirection: "column",
		alignItems: "flex-start",
		alignSelf: "stretch",
		flexGrow: 0
	}
}))
